<template>
  <div class="sku-test-trek__cta">
    <a :href="url" :target="target" class="button button--primary button--hollow" :class="cssClass" v-html="linkName" />
  </div>
</template>
<script>
import get from 'lodash/get';
export default {
  name: 'PdpBuyingZoneCmsLink',
  props: {
    options: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    linkName() {
      return get(this.options, 'linkName');
    },
    cssClass() {
      if (!this.options) {
        return [];
      }

      let cssClass = [];
      if (this.options.trekLinkStyle) {
        cssClass.push(this.options.trekLinkStyle);
      }

      if (this.options.cssClass) {
        cssClass.push(this.options.cssClass);
      }

      return cssClass;
    },
    url() {
      return get(this.options, 'url');
    },
    target() {
      return get(this.options, 'target') === 'SAMEWINDOW' ? '' : '_blank';
    },
  },
};
</script>
